// extracted by mini-css-extract-plugin
module.exports = {"SignupForm_buttonWrapper":"SignupForm_SignupForm_buttonWrapper__bltld","SignupForm_success":"SignupForm_SignupForm_success__AL5XM"};